import { valueOf } from "@/types/common";

export const MASTER_DATA_TYPE = {
  NATIONALITY: "nationality",
  RESIDENCE_PERIOD: "residence_period",
  JOB_TYPE: "job_type",
  MAIN_OCCUPATION: "main_occupation",
  MAIN_INDUSTRY: "main_industry",
  SKILL_TEST: "skill_test",
  BUSINESS_CLASSIFICATION: "business_classification",
  LANGUAGE_TEST: "language_test",
  SUPPORT_LANGUAGE: "support_language",
  COMPANY_SPECIFIC_INDUSTRY: "company_specific_industry",
  ATTACHMENT_DOCUMENT_TYPE: "attachment_document_type",
  SPECIFIC_SKILL_CERTIFICATE: "specific_skill_certificate",
};

export type TMasterDataType = valueOf<typeof MASTER_DATA_TYPE>;

export const MASTER_DATA_TYPE_TITLE = {
  SKILL_TEST: "技能試験",
  BUSINESS_CLASSIFICATION: "取扱業務等の区分",
  MAIN_INDUSTRY: "主たる業種",
  NATIONALITY: "国籍",
  RESIDENCE_PERIOD: "在留資格／在留期間",
  COMPANY_SPECIFIC_INDUSTRY: "特定産業分野・区分",
  JOB_TYPE: "技能実習　職種／作業",
  SUPPORT_LANGUAGE: "言語",
  LANGUAGE_TEST: "日本語能力・資格",
  ATTACHMENT_DOCUMENT_TYPE: "人材添付書類の種類",
  SPECIFIC_SKILL_CERTIFICATE: "特定技能合格証",
};
